import { render, staticRenderFns } from "./PremiumMessageSendComplete.vue?vue&type=template&id=6b17c377&scoped=true&"
import script from "./PremiumMessageSendComplete.vue?vue&type=script&lang=js&"
export * from "./PremiumMessageSendComplete.vue?vue&type=script&lang=js&"
import style0 from "./PremiumMessageSendComplete.vue?vue&type=style&index=0&id=6b17c377&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b17c377",
  null
  
)

export default component.exports